import { Box, Button, Divider, Grid, ListItemText } from "@mui/material";
import React, { useState } from "react";
import utils from "../../../utils";

import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { useSnackbar } from "notistack";
import AuthService from "../../../AuthService";
const ShowComplementsList = ({
  complementoItem,
  produto,
  complementos,
  index,
  produtosBuscados,
  saveProdutosBuscados,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(null);

  const handleClickStopAndPause = (event, item, complemento) => {
    event.stopPropagation();
    setLoading(true);

    let service = new AuthService();
    const json = { id: item.id, produtoId: produto.id };

    service
      .put("/complementoItem/play-or-pause", json)
      .then((resp) => {
        let compItemIndex = complemento.complementoItens.findIndex(
          (el) => el.id === item.id
        );
        let compIndex = produto.complementos.findIndex(
          (el) => el.id === complemento.id
        );
        const newProduto = { ...produto };
        newProduto.complementos[compIndex] = {
          ...newProduto.complementos[compIndex],
          complementoItens: [
            ...newProduto.complementos[compIndex].complementoItens,
          ],
        };
        newProduto.complementos[compIndex].complementoItens[compItemIndex] =
          resp;
        const updatedProdutos = produtosBuscados.map((p) =>
          p.id === newProduto.id ? newProduto : p
        );
        saveProdutosBuscados(updatedProdutos);
        enqueueSnackbar(
          `Sub item ${resp.pausado ? "ativado" : "pausado"} com sucesso!`,
          {
            variant: "success",
          }
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment key={complementoItem.id}>
      <Grid sx={{ padding: "0.5rem" }} container direction="row">
        <Grid
          size={{
            xs: 8,
            sm: 8,
          }}
        >
          <ListItemText
            primary={complementoItem.descricao}
            secondary={utils.formatNumber(complementoItem.valor)}
          />
        </Grid>

        <Grid
          size={{
            xs: 4,
            sm: 4,
          }}
        >
          <Box
            sx={{
              height: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              cursor: loading ? "progress" : "pointer",
            }}
          >
            <Button
              disabled={loading}
              startIcon={
                complementoItem.pausado ? (
                  <PlayCircleOutlineIcon />
                ) : (
                  <PauseCircleOutlineIcon />
                )
              }
              color={complementoItem.pausado ? "secondary" : "primary"}
              onClick={(event) => {
                handleClickStopAndPause(event, complementoItem, complementos);
              }}
            >
              {complementoItem.pausado ? "Iniciar" : "Pausar"}
            </Button>
          </Box>
        </Grid>
      </Grid>

      {index < complementos.complementoItens.length - 1 && <Divider />}
    </React.Fragment>
  );
};

export default ShowComplementsList;
